module.exports = __webpack_public_path__ + "static/th-c4b0c8f36bd1062527c6c1d1e320bed6.svg";